import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Currency } from '../interfaces/currency';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class PricesService {

  // Table Top Prices
  // Concrete
  public concrete: number;

  // Glass
  public clear: number;
  public dark: number;

  // Marble
  public calacatta: number;
  public carrara: number;
  public emperador: number;
  public statuary: number;

  // Wood
  public ash: number;
  public oak: number;
  public pine: number;

  // Pricing Costs
  public delivery: number;
  public discount: number;
  public markup: number;
  public ownDiscount: number;
  public renewDiscount: number;
  public taxVal: number;

  // Currency Properties
  public currency: Currency[];
  public exchangeRate: number;
  public isZAR: boolean;
  public selectedCurrency: string;

  currencyCollection: AngularFirestoreCollection<Currency> ;
  prices: Observable<Currency[]>;


  constructor(
    private database: AngularFirestore,
    private http: HttpClient
  ) {
    // Concrete
    this.concrete = 250;

    // Glass
    this.clear = 260;
    this.dark = 270;

    // Marble
    this.calacatta = 280;
    this.carrara = 290;
    this.emperador = 300;
    this.statuary = 310;

    // Wood
    this.ash = 320;
    this.oak = 330;
    this.pine = 340;

    // Pricing Costs
    this.delivery = 280;
    this.discount = 80;
    this.markup = 130;
    this.ownDiscount = 10;
    this.renewDiscount = 15;
    this.currencyCollection = this.database.collection<Currency>('currency');
    this.taxVal = 15;
  }

  public getCost(propertyName): number {
    if (propertyName === 'concrete') {
      return this.concrete;
    } else if (propertyName === 'clear') {
      return this.clear;
    } else if (propertyName === 'dark') {
      return this.dark;
    } else if (propertyName === 'calacatta') {
      return this.calacatta;
    } else if (propertyName === 'carrara') {
      return this.carrara;
    } else if (propertyName === 'emperador') {
      return this.emperador;
    } else if (propertyName === 'statuary') {
      return this.statuary;
    } else if (propertyName === 'ash') {
      return this.ash;
    } else if (propertyName === 'oak') {
      return this.oak;
    } else if (propertyName === 'pine') {
      return this.pine;
    }
  }

  public monthlySubscriptionPrices(discount: number, month: number, cost: number): number {
    const monthlyPremium = cost * (this.discount / 100);
    const monthlyCost = (cost * (this.discount / 100)) / month;
    const correctCost = (Math.round(monthlyCost / 10) * 10) - 5;

    // console.table([
    //   [ 'monthlyPremium', monthlyPremium ],
    //   [ 'monthlyCost', monthlyCost ],
    //   [ 'correctCost', correctCost ]
    // ]);

    return correctCost;
  }

  public parseJSON(currency) {
    this.http.get('https://free.currconv.com/api/v7/convert?q=ZAR_' + currency + '&compact=ultra&apiKey=00e4755b64ca122a1699', {observe: 'response'}).subscribe( res => {
      console.log(res.body);
      if (currency === 'USD') {
        this.exchangeRate = res.body['ZAR_USD'];
      } else if (currency === 'GBP') {
        this.exchangeRate = res.body['ZAR_GBP'];
      }
    });
  }

  public sellingPrice(cost: number, delivery: number, markup: number, taxVal: number): number {
    const markupVal = markup * cost / 100;
    const deliveryCost = delivery;
    const priceWithoutTax = cost + markupVal + deliveryCost;
    const tax = taxVal * priceWithoutTax / 100;
    const priceWithTax = priceWithoutTax + tax;
    const retailPrice = Math.round(priceWithTax / 10) * 10;
    const retailSellingPriceIncVat = retailPrice - 5;
    const retailSellingPriceExVat = Math.round((retailSellingPriceIncVat / ((taxVal / 100) + 1)) * 100) / 100;
    const invoiceableTax = Math.round((retailSellingPriceIncVat - retailSellingPriceExVat) * 100) / 100;

    // console.table([
    //   [ 'markupVal', markupVal ],
    //   [ 'deliveryCost', deliveryCost ],
    //   [ 'priceWithoutTax', priceWithoutTax ],
    //   [ 'tax', tax ],
    //   [ 'priceWithTax', priceWithTax ],
    //   [ 'retailPrice', retailPrice ],
    //   [ 'retailSellingPriceIncVat', retailSellingPriceIncVat ],
    //   [ 'retailSellingPriceExVat', retailSellingPriceExVat ]
    // ]);

    return retailSellingPriceIncVat;
  }

  public tableSellingPrice(cost: number, delivery: number, depth: number, markup: number, rectangle: boolean, table: string, topCost: number, taxVal: number, width: number): number {
    const tableTopCost = ((depth * width) / 1000000) * topCost;
    const markupVal = markup * (cost + tableTopCost) / 100;
    const deliveryCost = delivery;
    const priceWithoutTax = (cost + tableTopCost) + markupVal + deliveryCost;
    const tax = taxVal * priceWithoutTax / 100;
    const priceWithTax = priceWithoutTax + tax;
    const retailPrice = Math.round(priceWithTax / 10) * 10;
    const retailSellingPriceIncVat = retailPrice - 5;

    return retailSellingPriceIncVat;
  }

  public updateCurrency(currency: Currency) {
    this.database.collection('currency')
      .doc('currency')
      .set({
        currency: currency
      }, {
        merge: false
      });
  }
}
